import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { MARKETPLACE_URL } from "./shared";
import { Logo } from "./Logo";

const links = [
  { label: "Docs", href: "#docs" },
  { label: "Workflows", href: "#workflows" },
  { label: "Support", href: "#support" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled ? "border-white/10 bg-black/70 backdrop-blur-xl" : "border-transparent bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full max-w-screen-2xl items-center justify-between px-6 md:px-12">
        <a href="#top" data-testid="nav-logo" className="group flex items-center gap-2">
          <Logo className="h-7 w-7 transition-transform duration-200 group-hover:scale-105" withWordmark testId="nav-logo-mark" />
        </a>

        <div className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-400 transition-colors duration-200 hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href={MARKETPLACE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-marketplace-button"
          className="group hidden items-center gap-2 bg-primary px-5 py-2.5 font-mono text-xs uppercase tracking-widest text-white transition-colors duration-200 hover:bg-[#FF7733] sm:flex"
        >
          Launch in AWS Marketplace
          <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </nav>
    </header>
  );
};
